import React from 'react';
import { Link } from 'react-router-dom';
import travelersLogo from '../media/travelers-logo.png';
import './Navbar.css';

const Navbar = () => {
  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <Link to="/">
          <img 
            src={travelersLogo} 
            alt="York Travelers Logo" 
            className="navbar-logo"
          />
        </Link>
      </div>
      <div className="navbar-links">
        <Link to="/">Home</Link>
        <Link to="/about">About</Link>
        <Link to="/plane">Plane</Link>
        <Link to="/join">Join</Link>
        <Link to="/contact">Contact</Link>
        <Link to="/gallery">Gallery</Link>
        <Link to="/history">History</Link>
      </div>
    </nav>
  );
};

export default Navbar; 